import { render, staticRenderFns } from "./email-status.vue?vue&type=template&id=c0a06d0c&"
import script from "./email-status.vue?vue&type=script&lang=js&"
export * from "./email-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports